import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

// Automatically shows a Bootstrap modal when connected
// Used for dynamic modals like unauthorized errors
export default class extends Controller {
  connect() {
    // Show the modal immediately when connected
    this.modal = new bootstrap.Modal(this.element)
    this.modal.show()

    // Clean up when modal is hidden
    this.element.addEventListener('hidden.bs.modal', this.cleanup.bind(this), { once: true })
  }

  cleanup() {
    // Remove the modal container from DOM after it's hidden
    const container = this.element.closest('#unauthorized_modal_container')
    if (container) {
      // Clear the container but keep it for future use
      container.innerHTML = ''
    }
  }

  disconnect() {
    // Ensure modal is hidden if controller disconnects
    if (this.modal) {
      this.modal.hide()
    }
  }
}
